<template>
  <div>
    <div class="row m-0 table-row">
      <div class="col-4 py-2 px-3">
        <div
          @click="toggleChildren"
          class="d-flex align-items-center parent-title"
        >
          <div
            v-if="permission.children && permission.children.length > 0"
            :class="['arrow', showChildren ? 'arrow-bottom' : '']"
          >
            <i class="fa fa-chevron-right arrow"></i>
          </div>
          <p class="m-0">{{ parsedParentPermission.name }}</p>
        </div>
      </div>
      <div class="col-2 py-2 px-3 d-flex align-items-center">
        <checkbox
          :active="parsedParentCheckbox('read') === 'active'"
          :partial="parsedParentCheckbox('read') === 'partial'"
          :disabled="!parsedParentPermission.access['read']"
          @change="onChangeParent($event, 'read')"
        />
      </div>
      <div class="col-2 py-2 px-3 d-flex align-items-center">
        <checkbox
          :active="parsedParentCheckbox('create') === 'active'"
          :partial="parsedParentCheckbox('create') === 'partial'"
          :disabled="!parsedParentPermission.access['create']"
          @change="onChangeParent($event, 'create')"
        />
      </div>
      <div class="col-2 py-2 px-3 d-flex align-items-center">
        <checkbox
          :active="parsedParentCheckbox('update') === 'active'"
          :partial="parsedParentCheckbox('update') === 'partial'"
          :disabled="!parsedParentPermission.access['update']"
          @change="onChangeParent($event, 'update')"
        />
      </div>
      <div class="col-2 py-2 px-3 d-flex align-items-center">
        <checkbox
          :active="parsedParentCheckbox('delete') === 'active'"
          :partial="parsedParentCheckbox('delete') === 'partial'"
          :disabled="!parsedParentPermission.access['delete']"
          @change="onChangeParent($event, 'delete')"
        />
      </div>
    </div>
    <hr class="m-0" />
    <!-- This part when there is children in the permission -->
    <template v-if="showChildren">
      <div
        v-for="(item, index) in parsedChildrenPermission"
        class="row m-0 table-row"
        :key="index"
      >
        <div class="col-4 py-2 px-3">
          <div class="child-title">
            <p class="m-0">{{ item.name }}</p>
          </div>
        </div>

        <div class="col-2 py-2 px-3 d-flex align-items-center">
          <checkbox
            :active="permissionValue.includes(item.access['read'])"
            :partial="false"
            :disabled="!item.access['read']"
            @change="onChangeChild($event, 'read', item.access)"
          />
        </div>
        <div class="col-2 py-2 px-3 d-flex align-items-center">
          <checkbox
            :active="permissionValue.includes(item.access['create'])"
            :partial="false"
            :disabled="!item.access['create']"
            @change="onChangeChild($event, 'create', item.access)"
          />
        </div>
        <div class="col-2 py-2 px-3 d-flex align-items-center">
          <checkbox
            :active="permissionValue.includes(item.access['update'])"
            :partial="false"
            :disabled="!item.access['update']"
            @change="onChangeChild($event, 'update', item.access)"
          />
        </div>
        <div class="col-2 py-2 px-3 d-flex align-items-center">
          <checkbox
            :active="permissionValue.includes(item.access['delete'])"
            :partial="false"
            :disabled="!item.access['delete']"
            @change="onChangeChild($event, 'delete', item.access)"
          />
        </div>

        <hr class="m-0 col-12" />
      </div>
    </template>
  </div>
</template>

<script>
import { Checkbox } from "@/components/Input";

export default {
  name: "InternalCheckboxWrapper",
  components: { Checkbox },
  props: {
    permission: {
      type: Object,
      required: true,
    },
    permissionValue: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showChildren: true,
    };
  },
  computed: {
    parsedParentCheckbox() {
      return (type) => {
        if (
          !this.permissionValue ||
          !this.parsedChildrenPermission ||
          this.parsedChildrenPermission.length <= 0
        )
          return "";

        const allAccess = this.getAllChildrenAccess(type)

        let activeCount = 0;

        for (let i = 0; i < allAccess.length; i++) {
          if (this.permissionValue.includes(allAccess[i])) {
            activeCount++;
          }
        }
        if ( allAccess.length > 0 && activeCount === allAccess.length) return "active"
        if (activeCount > 0) return "partial"
        return "";
      };
    },
    parsedChildrenPermission() {
      if (!this.permission.children) return [];
      return this.permission.children.map((item) => {
        return {
          name: item.name,
          access: this.parsedAccess(item.children),
        };
      });
    },
    parsedParentPermission() {
      const access = {};
      if (!this.permission.children) {
        return {
          name: "",
          access: {},
        }
      }

      if (this.permission.children) {
        this.permission.children.forEach((element) => {
          if (element.children) {
            element.children.forEach((item) => {
              if (!access[item.type]) {
                access[item.type] = true;
              }
            });
          }
        });
      }

      return {
        name: this.permission.name,
        access,
      };
    },
  },
  methods: {
    getAllChildrenAccess (type) {
      return this.parsedChildrenPermission
          .map((item) => {
            return item.access[type];
          })
          .filter((item) => item !== undefined);
    },
    parsedAccess(value) {
      const access = {};
      if (value) {
        value.forEach((el) => {
          access[el.type] = el.permission;
        });
      }
      return access;
    },
    onChangeChild(value, type, access) {
      let result = this.permissionValue;
      if (!value.active) {
        // When read is unchecked, the rest of the access is removed
        if (type === 'read') {
          const allAvailableAccess = Object.values(access);
          result = result.filter((item) => !allAvailableAccess.includes(item));
        } else {
          result = result.filter((item) => item !== access[type]);
        }
      } else {
        // When non read is checked, the read access is automatically added if it is not already added
        if(type !== 'read' && access["read"] && !result.includes(access["read"])) {
          result.push(access["read"]);
        }
        result.push(access[type]);
      }
      this.$emit("change", result);
    },

    onChangeParent(value, type) {
      let result = this.permissionValue;
      const allAccess = this.getAllChildrenAccess(type);
      if (value.active) {
        // when parent other than read is checked, the rest of children read access is added if it is not already added
        if(type !== 'read') {
          const allReadAccess = this.getAllChildrenAccess('read');
          allReadAccess.forEach((el) => {
            if (!result.includes(el)) {
              result.push(el);
            }
          })
        }
        allAccess.forEach((el) => {
          if (!result.includes(el)) {
            result.push(el);
          }
        })
      } else {
        // when parent read is unchecked, the rest of children access is removed
        if (type === 'read') {
          const allAvailableAccess = []
          this.parsedChildrenPermission.forEach((item) => {
            allAvailableAccess.push(...Object.values(item.access))
          })
          result = result.filter((item) => !allAvailableAccess.includes(item));
        }
        allAccess.forEach((el) => {
          result = result.filter((item) => item !== el);
        })
      }
      this.$emit("change", result);
    },

    toggleChildren() {
      this.showChildren = !this.showChildren;
    },
  },
};
</script>

<style scoped>
label {
  margin-bottom: 0;
}

.table-row p {
  font-size: 14px;
  color: #374151;
}

.arrow {
  font-size: 12px;
  margin-right: 18px;
  transform: rotate(0deg);
  margin-bottom: 0;
  height: 14px;
  width: 14px;
}

.arrow-bottom {
  transform: rotate(90deg);
}

.child-title {
  margin-left: 50px;
}

.parent-title {
  font-weight: 600;
  cursor: pointer;
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/components/Employee/Components/RolesAndPermissions/CheckboxWrapper/Internal.vue